import { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../kits/button/CustomButton";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip.jsx";
import { ReactSelect } from "../kits/Inputs/Inputs.tsx";
import useAxios from "../../services/useAxios.tsx";
import { PlusSquareIcon } from "../kits/Icons.tsx";
import ToastCustomize from "../kits/ToastCustomize";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

export default function AddCue({ campaignId, steps, users, title, addCueApi }) {
  const [addCueShow, setAddCueShow] = useState(false);
  const { execute: createLead } = useAxios("api2/create_lead");
  const { execute: suitableLeads } = useAxios("api2/suitable_leads");
  const { execute: findSteps } = useAxios("api/Find_step");
  // const [steps, setSteps] = useState([]);
  // const [users, setUsers] = useState([]);
  const [selectedStep, setSelectedStep] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const { userInfo } = useContext(AuthenticationContext);

  useEffect(() => {
    // suitableLeads({ campaign_id: campaignId }).then(data => {
    //   if (data.status == "1") {
    //     for (let i = 0; i < data?.customers.length; i++) {
    //       let object = {};
    //       object.value = data?.customers[i].customers__id;
    //       object.label =
    //         data?.customers[i].firstname + " " + data?.customers[i].lastname;
    //       users.push(object);
    //     }
    //   }
    // });
    // findSteps({ conditions: `campaignId/=/${campaignId}` }).then(data => {
    //   if (data != "") {
    //     for (let i = 0; i < data?.steps.length; i++) {
    //       let object = {};
    //       object.value = data?.steps[i].id;
    //       object.label = data?.steps[i].title;
    //       steps.push(object);
    //     }
    //   }
    // });
  }, []);
  const addCue = () => {
    let fd = new FormData();
    fd.append("stepId", selectedStep.value);
    fd.append("campaignId", campaignId);
    fd.append("customerId", selectedUser.value);
    createLead(fd).then((data) => {
      if (data.status == 1) {
        ToastCustomize({
          mainText: "سرنخ با موفقیت اضافه شد",
          duration: 3000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setSelectedStep([]);
        setSelectedUser([]);
        setAddCueShow(false);
      } else if ((data.status = -5)) {
        ToastCustomize({
          mainText: "این سرنخ قبلا اضافه شده است.",
          duration: 3000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی در ثبت سرنخ پیش آمده است.",
          duration: 3000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };

  return (
    <>
      {userInfo.userRoll.includes(23) && (
        <CustomTooltip
          title="سرنخ جدید"
          placement="top"
          color="secondary_custom"
        >
          <div>
            <CustomButton
              className="shadow-none"
              onClick={() => {
                setAddCueShow(true);
                addCueApi(campaignId);
              }}
            >
              <PlusSquareIcon color="white"></PlusSquareIcon>
            </CustomButton>
          </div>
        </CustomTooltip>
      )}
      <Modal
        show={addCueShow}
        onHide={() => {
          setAddCueShow(false);
        }}
      >
        <Modal.Header closeButton>ایجاد سرنخ جدید برای {title} </Modal.Header>
        <Modal.Body>
          <div className="mt-2">
            <ReactSelect
              title="انتخاب استپ"
              itemsList={steps}
              inputValue={selectedStep}
              onChangeFunc={(e) => setSelectedStep(e)}
            ></ReactSelect>
          </div>
          <div className="mt-4">
            <ReactSelect
              title="انتخاب مشتری"
              itemsList={users.map((v) => {
                return {
                  value: v.value,
                  label: (
                    <div>
                      {v.corporate == 1
                        ? `${v.label}(${v.firstname} ${v.lastname})`
                        : `${v.firstname} ${v.lastname}`}
                    </div>
                  ),
                };
              })}
              inputValue={selectedUser}
              onChangeFunc={(e) => setSelectedUser(e)}
            ></ReactSelect>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex">
            <CustomButton
              type="outline"
              color="danger"
              className="mx-3"
              onClick={() => {
                setAddCueShow(false);
                setSelectedStep([]);
                setSelectedUser([]);
              }}
            >
              انصراف
            </CustomButton>
            <CustomButton type="outline" color="success" onClick={addCue}>
              ذخیره
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
